export enum MarketId {
  Chile = 1,
  Norway = 10,
  UnitedKingdom = 11,
  Canada = 12,
  Iceland = 13,
  Mexico = 14,
  Ecuador = 15,
  India = 864,
  Vietnam = 16,
}
